<template>
  <router-view />

  <!-- Mostrar alertas de manera reactiva -->
  <v-snackbar
    v-model="alertStore.visible"
    :timeout="alertStore.timeout"
    :color="alertStore.type"
    location="bottom center"
    multi-line
  >
    {{ alertStore.message }}
    <template #actions>
      <v-btn icon @click="alertStore.closeAlert">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>

  <!-- Snackbar de actualización PWA -->
  <v-snackbar
    v-model="showUpdate"
    timeout="-1"
    location="bottom"
    multi-line
    min-height="50px"
  >
    Hay una nueva versión disponible.
    <template #actions>
      <v-btn @click="refreshApp" size="small">
        Actualizar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { useAuthStore } from "@/store/auth";
import { useAlertStore } from "@/store/alertStore";
import { setAuthToken } from "@/plugins/axios";
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useCatalogsStore } from '@/store/catalogs';
export default {
  name: 'App',
  async created() {
    const authStore = useAuthStore();
    if (authStore.token) {
      setAuthToken(authStore.token); 
      try {
        await authStore.initializeUser();
        const catalogsStore = useCatalogsStore();
        catalogsStore.fetchCatalogs();
      } catch (error) {
        console.error("Failed to initialize user:", error);
      }
    }
  },
  setup() {
    const alertStore = useAlertStore();

    // --- Banner de nueva versión ---
    const showUpdate = ref(false);

    function refreshApp() {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistration().then((registration) => {
          if (registration && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            registration.waiting.addEventListener('statechange', (e) => {
              if (e.target.state === 'activated') {
                window.location.reload();
              }
            });
          } else {
            window.location.reload();
          }
        });
      } else {
        window.location.reload();
      }
    }

    // Escuchar evento global swUpdated
    function onSwUpdated() {
      showUpdate.value = true;
    }

    onMounted(() => {
      window.addEventListener('swUpdated', onSwUpdated);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('swUpdated', onSwUpdated);
    });

    return {
      alertStore,
      showUpdate,
      refreshApp,
    };
  }
};
</script>

<style>
.v-field{
    box-shadow: none !important;
}
</style>